import React, { memo } from 'react';
import { renderIcon } from '../../FlowchartView/utils/renderIcon';
import { MissionCardBody } from '../../shared/CardComponents';

/**
 * ColumnDragOverlay Component
 * Lightweight overlay using a DOM snapshot - no React re-renders during drag
 * This is MUCH faster than rendering actual React components
 */
export const ColumnDragOverlay = memo(({ snapshot, column }) => {
  // Use DOM snapshot if available (fast path)
  if (snapshot?.html) {
    return (
      <div 
        className="kanban-column-drag-wrapper"
        style={{ width: snapshot.width, height: snapshot.height }}
        dangerouslySetInnerHTML={{ __html: snapshot.html }}
      />
    );
  }
  
  // Fallback: simple placeholder if snapshot not ready
  if (column) {
    return (
      <div 
        className="kanban-column-drag-wrapper kanban-column-drag-wrapper--fallback"
        style={{ '--column-color': column.color }}
      >
        <div className="kanban-column">
      <div className="kanban-column__header">
        <div className="kanban-column__header-top">
          <span className="kanban-column__color-dot" style={{ background: column.color }} />
          <span className="kanban-column__label">{column.name}</span>
      </div>
          </div>
    </div>
  </div>
);
  }
  
  return null;
});

/**
 * SwimlaneColumnOverlay Component (Simple version)
 * Rendered in DragOverlay when dragging a column in swimlane mode
 * Shows only the column header for a compact overlay that stays near the cursor
 */
export const SwimlaneColumnOverlay = memo(({ column, count }) => (
  <div className="kanban-swimlane-column-overlay">
    <span className="kanban-swimlanes__header-color" style={{ backgroundColor: column.color }} />
    <span className="kanban-swimlanes__header-label">{column.name}</span>
    <span className="kanban-swimlanes__header-count">{count}</span>
  </div>
));

/**
 * CardOverlay Component
 * Rendered in DragOverlay when dragging a card
 * Shows the full card content using MissionCardBody
 */
export const CardOverlay = memo(({ card, category, statuses = [], allTags = [], nestedSprint = null, cardDisplaySettings = {} }) => (
  <div 
    className="kanban-card kanban-card--overlay"
    style={{
      '--category-color': category?.color || 'transparent',
      '--category-bg': category ? `${category.color}18` : 'transparent',
    }}
  >
    <MissionCardBody
      task={card}
      category={category}
      allTags={allTags}
      statuses={statuses}
      nestedSprint={nestedSprint}
      isBlocked={card.isBlocked}
      cardDisplaySettings={cardDisplaySettings}
      showCategoryBar={false}
    />
  </div>
));

